/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback } from 'react'
import { Handle, Position } from '@xyflow/react'
import plcLogo from '@/assets/ditto.png'

const handleStyleLeftTarget = { left: -2, top: 30 }
const handleStyleLeftSource = { left: -2, top: 100 }

function DittoNodeBi({ data, isConnectable }) {
  const onChange = useCallback((evt) => {}, [])

  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} />
      <Handle id="b" type="source" position={Position.Left} />

      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={plcLogo} alt="Ditto Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>Digital Twins</b>
          </div>
        </div>
      </div>

      <Handle id="a" type="source" position={Position.Right} />
    </div>
  )
}

export default DittoNodeBi
